<template>
  <div>
    <div v-if="allSpinning" style="width:100%;height:100%;position: fixed;left: 0;top: 0;background:rgba(0,0,0,0.6);z-index: 999999;display:flex;justify-content: center;align-items: center;">
      <a-spin :allSpinning="allSpinning" tip="加载中" :delay="100" size="large"></a-spin>
    </div>
    <div class="bjThing">
      <!-- 需关注老人1_7_30 -->
      <div :class="['bjLeft',gzOld_nowSelWhat == 30 ? 'heightAuto' : '']" style="width:100%;" v-if="new_gzOldData">
        <div class="b_comTopCont" v-if="gzOld_nowSelWhat == 1">
          <div class="dayNum">{{new_gzOldData.startDate | dataChange(new_gzOldData.startDate)}}</div>
          <div class="dayName">|</div>
          <div class="dayName">健康发生变化的长者</div>
          <div class="count" v-if="new_gzOldData.totleCount == 0">{{new_gzOldData.totleCount}}位</div>
          <div class="countRed" v-if="new_gzOldData.totleCount != 0">{{new_gzOldData.totleCount}}位</div>
          <div class="flex" style="margin-left: auto;">
            <div :class="['dayBtn',gzOld_nowSelWhat == 1 ? 'dayBtnSel' : '']" @click="cli_gzOld_nowSelWhat(1)">当日</div>
            <div :class="['dayBtn ml10',gzOld_nowSelWhat == 7 ? 'dayBtnSel' : '']" @click="cli_gzOld_nowSelWhat(7)">最近7天</div>
            <div :class="['dayBtn ml10',gzOld_nowSelWhat == 30 ? 'dayBtnSel' : '']" @click="cli_gzOld_nowSelWhat(30)">最近30天</div>
          </div>
        </div>
        <div class="b_comTopCont" v-if="gzOld_nowSelWhat == 7">
          <div class="dayNum">&nbsp;</div>
          <div class="dayName" style="margin-left: -5px;">健康发生变化的长者</div>
          <div class="count" v-if="new_gzOldData.totleCount == 0">{{new_gzOldData.totleCount}}位</div>
          <div class="countRed" v-if="new_gzOldData.totleCount != 0">{{new_gzOldData.totleCount}}位</div>
          <div class="dayRange">{{ new_gzOldData.startDate | dataChange(new_gzOldData.startDate) }}~{{ new_gzOldData.endDate | dataChange(new_gzOldData.endDate) }}</div>
          <div class="flex" style="margin-left: auto;">
            <div :class="['dayBtn',gzOld_nowSelWhat == 1 ? 'dayBtnSel' : '']" @click="cli_gzOld_nowSelWhat(1)">当日</div>
            <div :class="['dayBtn ml10',gzOld_nowSelWhat == 7 ? 'dayBtnSel' : '']" @click="cli_gzOld_nowSelWhat(7)">最近7天</div>
            <div :class="['dayBtn ml10',gzOld_nowSelWhat == 30 ? 'dayBtnSel' : '']" @click="cli_gzOld_nowSelWhat(30)">最近30天</div>
          </div>
        </div>
        <div class="b_comTopCont" v-if="gzOld_nowSelWhat == 30">
          <div class="dayNum">最近30天</div>
          <div class="dayName">|</div>
          <div class="dayName">需要关注的长者</div>
          <div class="count" v-if="home_moon_follow_data && home_moon_follow_data.totleCount == 0">{{home_moon_follow_data.totleCount}}位</div>
          <div class="countRed" v-if="home_moon_follow_data && home_moon_follow_data.totleCount != 0">{{home_moon_follow_data.totleCount}}位</div>
          <div class="flex" style="margin-left: auto;">
            <div :class="['dayBtn',gzOld_nowSelWhat == 1 ? 'dayBtnSel' : '']" @click="cli_gzOld_nowSelWhat(1)">当日</div>
            <div :class="['dayBtn ml10',gzOld_nowSelWhat == 7 ? 'dayBtnSel' : '']" @click="cli_gzOld_nowSelWhat(7)">最近7天</div>
            <div :class="['dayBtn ml10',gzOld_nowSelWhat == 30 ? 'dayBtnSel' : '']" @click="cli_gzOld_nowSelWhat(30)">最近30天</div>
          </div>
        </div>

        <!-- 有数据情况_单日_七日 -->
        <div v-if="new_gzOldData.resultFlag">
          <!-- 单日 -->
          <div style="position: relative;" v-show="gzOld_nowSelWhat == 1">
            <div class="btn_RB_see" @click="cli_gzListAll(1)">查看全部</div>
            <div class="flex bjOneDay">
              <!-- 床位列表 -->
              <div class="bedWrap" style="width: 100%">
                <div class="bedLine" style="left: 383px;"></div>
                <div class="bedLine" style="left: 770px;"></div>
                
                <div class="bedWrap" :style="{marginTop: 0,width: (new_gzOldData.needFollowPageListVoList.length < 6 || new_gzOldData.needFollowPageListVoList.length > 12) ? '100%' : '66.6%' }">
                  <div class="bedList" :key="index" v-for="(item,index) in new_gzOldData.needFollowPageListVoList" @click="open_tan_needGZ_single(item)">
                    <div class="bedName" style="width:328px;">{{ item.buAndFlName }}</div>
                    <div class="bedNum colorFF7186">{{ item.total }}项</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 七日 -->
          <div style="position: relative;" v-show="gzOld_nowSelWhat == 7">
            <div class="btn_RB_see" @click="cli_gzListAll(7)">查看全部</div>
            <div class="flex bjSevenDay">
              <div class="bjContWrap">
                <div class="bjEcWrap">
                  <div id="ec_id_bjbl2"></div>
                  <div class="bjEcTip2">需关注的老人比例</div>
                  <div class="bjEcTip" v-if="new_gzOldData.moreDayRedioList && new_gzOldData.moreDayRedioList.describe == '有上升趋势，护理人员需要提高警惕'">{{new_gzOldData.moreDayRedioList.describe}}</div>
                  <div class="bjEcTip bjEcTip_bgEBECEF" v-if="new_gzOldData.moreDayRedioList && new_gzOldData.moreDayRedioList.describe != '有上升趋势，护理人员需要提高警惕'">{{new_gzOldData.moreDayRedioList.describe}}</div>
                </div>
              </div>
              <!-- 床位列表 -->
              <!-- <div class="bedWrap ml10" style="width: 959px;"> -->
              <div class="bedWrap ml10" style="width: 959px;">
                <div class="bedLine" style="left: 316px;"></div>
                <div class="bedLine" style="left: 636px;"></div>
                <div class="bedWrap" :style="{width: (new_gzOldData.needFollowPageListVoList.length < 6 || new_gzOldData.needFollowPageListVoList.length > 12) ? '959px' : '629px',marginTop: 0 }">
                  <div class="bedList" :key="index" v-for="(item,index) in new_gzOldData.needFollowPageListVoList" @click="open_tan_needGZ_single(item)">
                    <div class="bedName" style="width:261px;">{{ item.buAndFlName }}</div>
                    <div class="bedNum colorFF7186">{{ item.total }}天</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="height: 20px;"></div>
        </div>
        <!-- 无数据情况_单日_七日 -->
        <div class="noData mt10" style="height:194px;" v-show="!new_gzOldData.resultFlag && (gzOld_nowSelWhat == 1 || gzOld_nowSelWhat == 7)">
          <div class="">{{ new_gzOldData.usageDscription }}</div>
        </div>
        <!-- 有数据情况_三十日 -->
        <div>
          <!-- 三十日 -->
          <div style="position: relative;" v-if="gzOld_nowSelWhat == 30 && home_moon_follow_data">
            <div class="bjContWrap bjContWrap_moon" v-if="home_moon_follow_data.resultFlag">
              <div class="oldState">
                <!-- 一个 -->
                <div class="o_table border_no" v-if="home_moon_follow_data.digitalTwinFollowCountList.length == 1">
                  <div class="o_tableList border_4444" :key="index2" v-for="(item2,index2) in home_moon_follow_data.digitalTwinFollowCountList">
                    <div class="o_name">{{ item2.content }}</div>
                    <div class="o_num">{{ item2.count }}位</div>
                  </div>
                </div>
                <!-- 两个 -->
                <div class="o_table border_no" v-if="home_moon_follow_data.digitalTwinFollowCountList.length == 2">
                  <div class="o_tableList" :key="index2" v-for="(item2,index2) in home_moon_follow_data.digitalTwinFollowCountList">
                    <div class="o_name">{{ item2.content }}</div>
                    <div class="o_num">{{ item2.count }}位</div>
                  </div>
                </div>
                <!-- 三个或四个 -->
                <div class="o_table border_no o_table_Three" style="margin-top: 50px;" v-if="home_moon_follow_data.digitalTwinFollowCountList.length > 2 && home_moon_follow_data.digitalTwinFollowCountList.length < 5">
                  <div class="o_tableList" :key="index2" v-for="(item2,index2) in home_moon_follow_data.digitalTwinFollowCountList">
                    <div class="o_name">{{ item2.content }}</div>
                    <div class="o_num">{{ item2.count }}位</div>
                  </div>
                </div>
                <!-- 五个或六个 -->
                <div class="o_table border_no o_table_Three" style="height: 262px;margin-top:3px;" v-if="home_moon_follow_data.digitalTwinFollowCountList.length > 4">
                  <div :key="index2" v-for="(item2,index2) in home_moon_follow_data.digitalTwinFollowCountList">
                    <div class="o_tableList" v-if="index2 < 5">
                      <div class="o_name">{{ item2.content }}</div>
                      <div class="o_num">{{ item2.count }}位</div>
                    </div>
                    <div class="o_tableList" v-if="index2 == 5">
                      <div class="o_name">...</div>
                      <div class="o_num">&nbsp;</div>
                    </div>
                  </div>
                </div>
                

                <div class="oRightWrap ml25">
                  <el-carousel height="270px" :interval="50000" arrow="never" :loop="false" indicator-position='none' ref="lb_moonFollow" @change="change_lb_follow">
                    <el-carousel-item :key="index" v-for="(item,index) in home_moon_follow_data.newList" >
                      <div class="oRightWrap" style="height: 270px;">
                        <div class="oRightList" :key="index2" v-for="(item2,index2) in item">
                          <div class="o_topBox">
                            <img class="peoIconImg" src="../../../assets/home_icon_avatar_h@2x.png" alt="">
                            <div class="oName">{{item2.buAndFlName}}</div>
                          </div>
                          <div class="flex mt10">
                            <div class="varSta">
                              <img class="tanhaoIcon" src="../../../assets/report_icon_notice_d@2x.png" alt="">
                              <div>{{item2.contentList[0]}}</div>
                            </div>
                            <div class="exceIcon" v-if="item2.contentList.length > 2">
                              <div class="threePoint">...</div>
                            </div>
                          </div>
                          <div class="flex mt10" v-if="item2.contentList[1]">
                            <div class="varSta">
                              <img class="tanhaoIcon" src="../../../assets/report_icon_notice_d@2x.png" alt="">
                              <div>{{item2.contentList[1]}}</div>
                            </div>
                          </div>
                          <div class="btnSee" @click="open_tan_needGz_portrait(item2)">查看</div>
                        </div>
                      </div>
                      
                    </el-carousel-item>
                  </el-carousel>
                  <div v-if="home_moon_follow_data.newList.length > 1">
                    <img class="backIcon backIcon_left" src="../../../assets/backIconLeft.png" alt="" @click="arrowClick_follow(1,'needGz')" v-if="home_moon_follow_lbPage != 1">
                    <img class="backIcon backIcon_left" src="../../../assets/backIconLeft2.png" alt="" @click="arrowClick_follow(1,'needGz')" v-if="home_moon_follow_lbPage == 1">
                    <img class="backIcon backIcon_right" src="../../../assets/backIconRight.png" alt="" @click="arrowClick_follow(2,'needGz')" v-if="home_moon_follow_lbPage != home_moon_follow_data.newList.length">
                    <img class="backIcon backIcon_right" src="../../../assets/backIconRight2.png" alt="" @click="arrowClick_follow(2,'needGz')" v-if="home_moon_follow_lbPage == home_moon_follow_data.newList.length">
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div style="height: 20px;"></div>
        </div>
        <!-- 无数据情况_三十日 -->
        <div v-if="gzOld_nowSelWhat == 30 && home_moon_follow_data && home_moon_follow_data.totleCount == 0">
          <div class="noData" style="height:194px;">
            <div class="">{{ home_moon_follow_data.usageDscription }}</div>
          </div>
        </div>
        <div style="height: 20px;" v-if="gzOld_nowSelWhat == 30 && home_moon_follow_data && home_moon_follow_data.totleCount == 0"></div>
        
        

       
      </div>
    </div>
    <!-- 弹窗_关注老人列表_1_7 -->
    <tan_needGz_list_one_seven ref="tan_needGz_list_one_seven"></tan_needGz_list_one_seven>
    <!-- 弹窗_关注老人单人详情 -->
    <tan_needGz_sin ref="tan_needGz_sin"></tan_needGz_sin>
    <!-- 弹窗_数字画像 -->
    <tan_needGz_portrait ref="tan_needGz_portrait"></tan_needGz_portrait>
  </div>
</template>

<script>
import portFn from '../../../utils/PortraitFunction.js';
import dataJson from './bbb.json'
import tan_needGz_list_one_seven from './tan_needGz_list_one_seven.vue';      //弹窗_关注老人列表_1_7
import tan_needGz_sin from './tan_needGz_sin.vue';      //弹窗_关注老人单人详情
import tan_needGz_portrait from './tan_needGz_portrait.vue';      //弹窗_数字画像
export default {
  components: { tan_needGz_list_one_seven,tan_needGz_sin,tan_needGz_portrait },
  filters: {
    dataChange(val){
      let newVal = val.slice(5,7) + '月' + val.slice(8,10) + '日'
      return newVal;
    },
  },
  props: {
    
  },
  watch: {
    
  },
  data() {
    return {
      allSpinning: true,
      // 需关注老人部分
      new_gzOldData: null,
      gzOld_nowSelWhat: 7,      //需关注老人当前选的什么  1单日 7七天 30月\

      
      home_moon_follow_data: null,    //首页_30天需关注数据

      home_moon_follow_lbPage: 1,     // 首页_30天需关注轮播当前页数
      
    };
  },
  created() {},
  mounted() {
    this.getNeedFollowTable()      //查看需要关注老人首页画图和数据展示
    
    
  },
  methods: {

    // 查看需要关注老人首页画图和数据展示
    getNeedFollowTable(){
      this.allSpinning = true;
      this.$get(
        'api/v4/home/getNeedFollowTable',
        {
          selectDateType: this.gzOld_nowSelWhat,
          pageSize: 18,
        },
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              this.new_gzOldData = res.data
              // 假数据
              // let falseData = {
              //   'bedId': 23,
              //   'buAndFlName': '副书记啊迪卢克放暑假了开发机打撒副书记啊迪卢克放暑假了开发机打撒副书记啊迪卢克放暑假了开发机打撒',
              //   'total': 4,
              // }
              // for(let i = 0;i < 17;i++){
              //   this.new_gzOldData.needFollowPageListVoList.push(falseData)
              // }
              // this.new_gzOldData.resultFlag = true;
              // 假数据end
              console.log(this.new_gzOldData)

              if(this.gzOld_nowSelWhat == 7 && this.new_gzOldData.resultFlag){
                // 需要关注老人_七天
                let needFollow ={
                  xAxis: {
                    data: this.new_gzOldData.moreDayRedioList.dateList
                  },
                  series: {
                    data: this.new_gzOldData.moreDayRedioList.ratioList
                    // data: this.weekData.moreDayRedioList
                  }
                }
                this.$nextTick((res) => {
                  this.getMyChart_optionLine('ec_id_bjbl2','bjbl',needFollow);        //需关注老人_七天
                })
              }
              this.$forceUpdate();
            } 
            this.allSpinning = false;
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },

    // 首页_需关注老人_点击当日或七天
    cli_gzOld_nowSelWhat(type){
      this.gzOld_nowSelWhat = type;
      if(type == 1 || type == 7){
        this.getNeedFollowTable()
      }else if(type == 30) {
        this.getHomeDigitalTwinFollowList();        //首页_查看最近30天需要关注老人
      }
    },
    
    // 点击关注老人中的查看全部 出全部弹窗 
    cli_gzListAll(type){
      let data = {type: type}
      this.$refs.tan_needGz_list_one_seven.openComponent_tan_needGz_list_one_seven(data)
    },
    // 点击关注老人中的某一个，出需关注单人详情
    open_tan_needGZ_single(data){
      let newData = data
      newData.nowType = this.gzOld_nowSelWhat
      this.$refs.tan_needGz_sin.openComponent(newData)
    },
    // 点击关注老人中的某一个，出需关注单人详情
    open_tan_needGz_portrait(data){
      this.$refs.tan_needGz_portrait.openComponent_tan_needGz_portrait(data)
    },

    
    // 首页_查看最近30天需要关注老人
    getHomeDigitalTwinFollowList(){
      let obj = {}
      this.$get(
        'api/v4/home/getHomeDigitalTwinFollowList',
        obj,
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              console.log(res.data)
              this.home_moon_follow_data = res.data;

              // for(let i = 0;i < 4;i++){
              //   this.home_moon_follow_data.digitalTwinFollowCountList.push(this.home_moon_follow_data.digitalTwinFollowCountList[i])
              // }
              // for(let i = 0;i < 18;i++){
              //   this.home_moon_follow_data.needFollowPageListVoList.push(this.home_moon_follow_data.needFollowPageListVoList[i])
              // }
             

              // 二维数组变一维数组start
              let voList = res.data.needFollowPageListVoList
              console.log(voList)
              let len = voList.length;
              let n = 8;
              let num = len % 8 === 0 ? len / 8 : Math.floor((len / 8) + 1)  //得出多少份
              let newList = []
              for (let i = 0; i < num; i++) {
                // slice() 方法返回一个从开始到结束（不包括结束）的数组。且原始数组不会被修改。
                const newArr = voList.slice(i * n, i * n + n) //得到每份的数据
                newList.push(newArr) //往res数组里加数据
              }
              console.log(newList, '二维数组')
              this.home_moon_follow_data.newList = newList
              // 二维数组变一维数组end


              // 会用于弹窗列表内
              this.tan_flagList_typeArr = []    //弹窗_报警列表_类别数组（早睡早起，睡得超安稳等）
              for(let i = 0;i < this.home_moon_follow_data.digitalTwinFollowCountList.length;i++){
                this.home_moon_follow_data.digitalTwinFollowCountList[i].isSelect = true;
                this.tan_flagList_typeArr.push(this.home_moon_follow_data.digitalTwinFollowCountList[i].index)
              }
              console.log(this.home_moon_follow_data)
              this.$forceUpdate()
            } 
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 首页_30天需关注点击轮播图按钮 type 左按钮1 右按钮2    whatType 需关注needGz 状态优秀good
    arrowClick_follow(type,whatType){
      if(whatType == 'needGz'){
        if(type == 1){
          this.$refs.lb_moonFollow.prev()
        }else {
          this.$refs.lb_moonFollow.next()
        }
      }else if(whatType == 'good'){
        if(type == 1){
          this.$refs.lb_moonFollow2.prev()
        }else {
          this.$refs.lb_moonFollow2.next()
        }
      }
    },
    // 首页_需关注老人_轮播切换时触发
    change_lb_follow(){
      let activeIndex = this.$refs.lb_moonFollow.activeIndex
      this.home_moon_follow_lbPage = Number(activeIndex + 1)
    },
    // 首页_需关注老人_轮播切换时触发
    change_lb_follow2(){
      let activeIndex = this.$refs.lb_moonFollow2.activeIndex
      this.home_moon_foGood_lbPage = Number(activeIndex + 1)
    },
    
    



    // 公共折线图
    getMyChart_optionLine(idName, type, olddata) {
      let data = olddata
      // type  报警比例bjbl   弹窗_报警列表_报警比例_七天seven_bjbl   弹窗_睡眠整体情况查看异常tan_smAbn
      this.myChart_Line = this.$echarts.init(document.getElementById(idName));
      console.log(idName, type, data)

      let maxNum = Math.max(...data.series.data)
      let yAxis_max = Math.round(maxNum / 10) * 10 + 10
      
      
      let series_itemStyle_color = ['#1890FF','#1890FF']
      

      let grid_left = '0.5%'
      let grid_bottom = '1%'

      if(type == 'bjbl'){             //报警比例
        yAxis_max = null
        // data.xAxis.data = []
        grid_bottom = '4%'
      } else if(type == 'seven_bjbl'){
        yAxis_max = null
      } else if(type == 'tan_smAbn'){
        yAxis_max = null
      }
      var optionLine = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255, 255, 255, 1)',
          borderColor: 'rgba(24, 144, 255, 0.6)',
          borderWidth: 1,
          spanStyle: {
            color: '#fff',
          },
          confine: true,
          borderRadius: 5,
          formatter: function(params) {
            console.log(type);
            console.log(params);
            if (type == 'bjbl') {      //报警比例
              return (
                // params[0].name +
                // '<br/>' +
                // '<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
                // params[0].data + '%'


                params[0].name +
                '<br/>' +
                '<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
                params[0].data + '%'
              );
            } else if(type == 'seven_bjbl' || type == 'tan_smAbn'){
              return (
                params[0].name +
                '<br/>' +
                '<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
                params[0].data + '%'
              );
            }
          },
        },
        grid: {
          left: grid_left,
          // left: '0%',
          right: '0.5%',
          top: '15%',
          bottom: grid_bottom,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: data.xAxis.data,
            axisLabel: {
              // interval: 10,
              // spanStyle: {
              //   color: '', //坐标的字体颜色
              // },
              textStyle: {
                color: '#5E6779',
                fontSize:'10',
                itemSize:'',
              },
              show: type == 'bjbl' ? false : true
            },
            axisLine: {
              lineStyle: {
                color: '#9094A6',
              },
            },
            
            axisTick: {
              show: false,
              // alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            max: yAxis_max,
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#CACDD9'
              }
            },
            // minInterval: 1100, //设置最小间隔为1，防止出现小数
            minInterval: 1, //设置最小间隔为1，防止出现小数
            axisLabel: {
              // spanStyle: {
              //   color: '#5E6779', //坐标的字体颜色
              // },
              textStyle: {
                color: '#5E6779',
                fontSize:'10',
                itemSize:''
              }
            },
            axisLine: {
              lineStyle: {
                color: '#c7c6c9',
              },
              show: false,
            },
            splitNumber: 1,
          },
        ],
        series: [
          {
            data: data.series.data,
            type: 'line',
            barWidth: 20,
            // symbol: 'none',
            lineStyle:{           //线条颜色
              color:'#1890FF'
            },
            // smooth: true,         //平滑处理
            symbol: 'circle',
            showSymbol: type == 'bjbl' ? false : true,
            symbolSize: 8,
            color: '#1890FF',
            areaStyle: type == 'seven_bjbl' || type == 'tan_smAbn' ? {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(24, 144, 255, 0.4)', // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgba(24, 144, 255, 0.05)', // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            } : null,
            markLine: type == 'tan_smAbn' ? {
              symbol: 'none',
              emphasis: {
                lineStyle: {
                  width: 1, // hover时的折线宽度
                },
              },
              data: [
                {
                  silent: false, //鼠标悬停事件  true没有，false有
                  lineStyle: {
                    //警戒线的样式  ，虚实  颜色
                    type: 'dashed',
                    color: '#63B2FB',
                  },
                  label: {
                    position: 'end',
                    formatter: '',
                  },
                  yAxis: data.avg, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
                },
              ],
            } : null,
          }
          
        ]
      }
      this.myChart_Line.setOption(optionLine,true);
      window.addEventListener('resize', () => {
        this.myChart_Line.resize();
      });
      this.$forceUpdate()
    },


    
    
  },
};
</script>
<style lang="scss" scoped>
@import '../../../assets/css/comHome.scss';

.noData{
  width: 100%;
  height: 100%;
  background: #F7F8FA;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #A5A9BC;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.backIcon{
  width: 57px;
  height: 57px;
  display: block;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.backIcon_left{
  left: -15px;
  z-index: 999;
}
.backIcon_right{
  right: -15px;
  z-index: 999;
}
// 轮播图部分
.el-carousel{
  width: 874px !important;
  height: 270px !important;
  .el-carousel__item:nth-child(2n) {
    // background-color: #ccc;
  }
  .el-carousel__item:nth-child(2n+1) {
    // background-color: pink;
  }
}





#ec_id_bjbl2{
  width: 171px;
  height: 105px;
  margin: 0 auto;
}

</style>
